import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import Card from '../Card/Card';
import CustomButton from '../CustomButton/CustomButton';
import { EstimateReminderModel } from './EstimateReminders';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

interface EstimateReminderProps {
  estimateId: number;
  reminder: EstimateReminderModel;
  refreshReminders: () => void;
}

type EstimateReminderFormFields = {
  reminderAt: string;
};

export default function EstimateReminder({
  estimateId,
  reminder,
  refreshReminders,
}: EstimateReminderProps) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<EstimateReminderFormFields>({ mode: 'onBlur' });

  const {
    user: { organization },
  } = useAuth();

  const onSubmit = async (estimateReminder: EstimateReminderFormFields) => {
    if (reminder.id) {
      await api.patch(
        `organizations/${organization.id}/estimates/${estimateId}/reminders/${reminder.reminderId}`,
        {
          reminderAt: estimateReminder.reminderAt,
        }
      );
    } else {
      await api.post(
        `organizations/${organization.id}/estimates/${estimateId}/reminders`,
        {
          reminder: reminder.reminderId,
          reminderAt: estimateReminder.reminderAt,
        }
      );
    }

    toast.success('A data foi registrada com sucesso');
    refreshReminders();
  };

  useEffect(() => {
    reset({
      reminderAt: reminder.reminderAt?.substring(0, 19),
    });
  }, [reminder]);

  return (
    <form>
      <Card title={reminder.description} titleStyle={{ marginTop: '.5rem' }}>
        {reminder.isRequired && (
          <span className='position-absolute top-0 end-0 badge bg-danger bg-opacity-75 m-1'>
            Obrigatório
          </span>
        )}
        <input
          className='form-control'
          placeholder='Data'
          type='datetime-local'
          required
          {...register('reminderAt', { required: true })}
        />

        {errors.reminderAt && (
          <div className='form-text text-danger'>
            {errors.reminderAt.message}
          </div>
        )}

        <div className='text-end'>
          <CustomButton
            type='button'
            className='btn btn-secondary mt-2'
            handleClick={handleSubmit(onSubmit)}
          >
            Salvar
          </CustomButton>
        </div>
      </Card>
    </form>
  );
}
